import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="page-404" className="min-h-[70vh] grid place-items-center px-6 text-center">
      <div>
        <p className="label-eyebrow">/ 404</p>
        <h1 className="font-heading mt-4 text-5xl md:text-7xl font-black uppercase tracking-tighter">
          Page not <span className="copper-text">found.</span>
        </h1>
        <p className="mt-4 text-zinc-400">The page you&apos;re looking for doesn&apos;t exist.</p>
        <Link
          to="/"
          data-testid="notfound-cta"
          className="mt-8 inline-block px-6 py-3 copper-bg text-black font-semibold uppercase tracking-widest text-sm"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}
